// extracted by mini-css-extract-plugin
var _1 = "YIo2FD6s1bzcKTknYii7";
var _2 = "bmeNSZJ2aVfDx_Woafa5";
export { _1 as "group", _2 as "header" }
